import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";
import {RateTechnicianModal} from "../../Modals/rateTechnicianModal";
import {setPaymentModal} from "../../../Store/Slice/techsbookSlice";
import {EditJobPrimaryContact} from "../../Modals/EditJobPrimaryContact";
import Button from "../../../UI/Button";
import Stripe from "../../Stripe";
import Popup from "../../Popup";
import "./index.scss";

export default function Technician({renderAffirmModal, setRenderAffirmModal, handleMakePaymentWithAffirm}) {
  const dispatch = useDispatch()
  const {activeJob} = useSelector((state) => state.rootReducer.jobsSlice);
  const accountData = useSelector((state) => state.rootReducer.techsbookSlice.userData);
  const [showModal, setShowModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(false);
  const [showEditJobPrimaryContact, setShowEditJobPrimaryContact] = useState(false);

  const closeInfo = () => {
    dispatch(setPaymentModal(false));
    setRenderAffirmModal(false)
  };

  const toggleShowEditJobPrimaryContact = () => {
    setShowEditJobPrimaryContact(!showEditJobPrimaryContact);
  }

  const isAbleEditDesc = activeJob?.status === "needs_tech" || activeJob?.status === "pending" || activeJob?.status === "accepted" || activeJob?.status === "inprogress_way" || activeJob?.status === "inprogress_site";

  return (
    <>
      {renderAffirmModal && (
        <Popup closePopup={closeInfo} title="Affirm payment">
          <Stripe
              affirm={true}
              jobId={activeJob?.id}
              amount={activeJob?.price}
              paymentId={activeJob?.payments[0]?.id}
          />
        </Popup>
      )}
      {
        showEditJobPrimaryContact
            ? <EditJobPrimaryContact close={toggleShowEditJobPrimaryContact} />
            : null
      }
      <div className="technician">
        <RateTechnicianModal
          setShowModal={setShowModal}
          showModal={showModal}
        />
        {activeJob?.technician?.id && (
          <>
            <p className="technician__label">Technician</p>
            <div onClick={() => {
              setCurrentItem(activeJob?.technician);
            }} className="technician__info">
              <div className={`technician__info-wrapper ${(activeJob?.status !== 'completed' && activeJob?.status !== 'partial_no_show') ? 'not-line' : ''}`}>
                <div className="technician__info-left">
                  <div className="technician__info-avatar">
                    <img
                      src={
                        activeJob?.technician?.profile_image ||
                        "/assets/images/avatar-placeholder.png"
                      }
                      alt=""
                    />
                  </div>
                  <div>
                    <p className="technician__info-text">Assigned to</p>
                    <p className="technician__info-name">
                      {activeJob?.technician?.name}
                    </p>
                  </div>
                </div>
                {(activeJob?.technician !== null && activeJob?.technician?.technician_rating !== null) && (
                    <div className="technician__info-right">
                    <span>
                      <img src="/assets/icons/star-rate.svg" alt="star"/>
                    </span>
                      {activeJob?.technician?.technician_rating}
                    </div>
                )}
              </div>
              {(activeJob?.status === 'completed' || activeJob?.status === 'partial_no_show') && (
                <div
                  onClick={() => {
                    setShowModal(true);
                  }}
                  className="technician__info-btn"
                >
                <span>
                  <img src="/assets/icons/star-white.svg" alt="star"/>
                </span>
                  Rate job quality
                </div>
              )}
            </div>
            <div className="technician__hr"></div>
          </>
        )}
        {activeJob?.contacts && (
          <>
            <div className="technician__top">
              <p className="technician__label">Primary point of contact</p>
              {
                  isAbleEditDesc &&
                  <div className="jobInfo__edit-pen" onClick={toggleShowEditJobPrimaryContact}>
                    <img src="/assets/icons/edit-dark.svg" alt="pen"/>
                    <span>Edit</span>
                  </div>
              }

            </div>
            <div className="technician__contacts">
              <p className="technician__contacts-name">
                {activeJob?.contacts[0]?.firstname} {activeJob?.contacts[0]?.lastname}
              </p>
              <div className="technician__contacts-contact">
          <span>
          <img src="/assets/icons/phone.svg" alt="phone"/>
          </span>
                {activeJob?.contacts[0]?.phone}
              </div>
              <div className="technician__contacts-contact">
          <span>
          <img src="/assets/icons/email-icon.svg" alt="email"/>
          </span>
                {activeJob?.contacts[0]?.email}
              </div>
            </div>
          </>
        )}
        <div className="technician__payment">
          <p className="technician__label mt-10">Job Payment status
            <div className={`technician__payment_status mt-10 ${activeJob?.payment_status}`}>
              <div className={`technician__payment-dot ${activeJob?.payment_status} `}></div>
              {activeJob?.payment_status === 'hold' ? 'paid' : activeJob?.payment_status?.split("_")
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))?.join(" ")}
            </div>
          </p>
          <p className="technician__label mt-10">Payments</p>
          {
            activeJob?.payments?.map((payment) => (
                <div key={payment.id} className="technician__payment-block">
                  <div className="technician__payment-header">
                    <div className="card">
                      {
                          payment?.method === 'card'
                            ? <img src='/assets/icons/credit-card.svg' alt="card"/>
                              : payment?.method === 'credits'
                                ? <img src='/assets/icons/credits.svg' alt="card"/>
                                : <img src='/assets/icons/afirm.svg' alt="card"/>
                      }
                      {
                          payment?.method === 'card'
                            ? <p>{payment?.payment_method?.payment_method_data?.brand ?? 'visa'}: {payment?.payment_method?.payment_method_data?.last4}</p>
                              : payment?.method === 'credits'
                                ? <p>Tokens</p>
                                : <p>Affirm</p>
                      }
                    </div>
                  </div>
                  <div className="technician__payment-hr"></div>
                  <div className="technician__payment-info">
                    <div className="technician__payment-amount">
                      <div className="technician__payment-text">Amount</div>
                      <p>{accountData?.country_currency_sign}{payment?.amount}</p>
                    </div>
                    <div className="technician__payment-status">
                      <div className="technician__payment-text">Payment status</div>
                      <div className={`technician__payment_status ${payment?.status}`}>
                        <div className={`technician__payment-dot ${payment?.status} `}></div>
                        {payment?.status === 'hold' ? 'paid' : payment?.status?.split("_")
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))?.join(" ")}
                      </div>
                    </div>
                  </div>

                  {(activeJob?.can_fill_affirm && payment?.status !== 'paid') && (
                      <Button
                          onClick={handleMakePaymentWithAffirm}
                          text={payment?.status === 'unpaid' ? 'Make a payment' : payment?.status === 'failed' ? 'Retry payment' : ''}
                          bottomPadding={11} topPadding={11}/>)}
                      {
                        (payment?.status === 'unpaid' || payment?.status === 'failed' || payment?.status === 'partial_paid')
                          &&
                          <Link to='/update-payment'
                                state={{job_id: activeJob?.id, job_datetime: activeJob?.job_datetime, type: payment?.method, payment_id: payment?.id}}
                          >
                            <Button style={{marginTop: '10px'}} text={'Change payment method'} bottomPadding={11} topPadding={11}/>
                          </Link>
                      }
                </div>
            ))
          }
        </div>
      </div>
    </>
  );
}
